module.exports = __webpack_public_path__ + "img/star_full.2706adae.svg";